import React from 'react'
import config from '../../config.json'
import Page from '../page/Page'
import SearchComponent from '../searchitems/'
import { BreadcrumbItem, Breadcrumbs } from '@nextui-org/react'

const Sales = (props) => {
    const collectionDetails = props['collection_details']
    const collectionName = collectionDetails ? collectionDetails['name'] : null
    const preview = collectionDetails ? collectionDetails['preview'] : null

    return (
        <Page
            id={'MarketPage'}
            title={config.titles.sales}
            description={config.descriptions.market.replace(
                '{collectionName}',
                collectionName ? collectionName + ', ' : '',
            )}
            image={preview}
            banners={false}
            {...props}
            pageTitle={'Discover Unique NFTs'}
            pageSubtitle={'   Explore Our Exclusive Collection for Sale'}
            breadcrumbs={[
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Sales',
                    link: '/sales',
                },
            ]}
        >
            <SearchComponent
                {...props}
                searchSettings={{
                    owner: '',
                    search_type: { value: 'trades', fixed: true },
                    order_by: { value: 'date_desc', fixed: false },
                    minimal: false,
                    tab: 'trades',
                    page_component: false,
                    limit: { value: 40, fixed: true },
                    expanded: false,
                }}
                limit={40}
                tab={'trades'}
            />
        </Page>
    )
}

export default Sales
